import { createTheme } from "@mui/material";

// Create a theme instance.
const myTheme = createTheme();

export default myTheme;